import * as React from 'react'
import { CLIENT_APP_URLS } from '@helpers/consts'
import { OfferDetailsRow } from '@modules/offers/common/details/offer-details-row'
import { OfferDetailsPersonalDataManualBoxPoint } from '@modules/offers/common/details/personal-data/offer-details-personal-data-manual-box-point'

export const SubscriptionContractManualBox = (): JSX.Element => (
  <OfferDetailsRow
    title={
      <span className="text-primary">
        <strong>Co</strong> musisz
        <strong className="d-block">zrobić?</strong>
      </span>
    }
  >
    <div className="subscription-with-benefit__personal-data__information-box gastro-card-boost__personal-data__information-box">
      <OfferDetailsPersonalDataManualBoxPoint number={1}>
        <strong className="text-primary">Zapoznaj się z opisem promocji </strong>i wybierz wariant oferty przygotowanej
        specjalnie dla Ciebie.
      </OfferDetailsPersonalDataManualBoxPoint>
      <OfferDetailsPersonalDataManualBoxPoint number={2}>
        Jesteś naszym stałym klientem? <strong className="text-primary">Zaloguj się! </strong> <br />
        Jesteś tu pierwszy raz? <strong className="text-primary">Uzupełnij swoje dane.</strong>
      </OfferDetailsPersonalDataManualBoxPoint>
      <OfferDetailsPersonalDataManualBoxPoint number={3}>
        <strong className="text-primary">Zaznacz odpowiednie zgody</strong> i potwierdź złożenie zamówienia. Kliknij w
        link otrzymanej wiadomości e-mail, sprawdź swoje dane <strong>i dokonaj płatności podając dane karty.</strong>
      </OfferDetailsPersonalDataManualBoxPoint>
      <OfferDetailsPersonalDataManualBoxPoint number={4}>
        <strong className="text-primary">Twoja Subskrypcja zostanie utworzona.</strong> Po zaksięgowaniu wpłaty
        otrzymasz potwierdzenie rozpoczęcia Subskrypcji wraz z jej numerem.
      </OfferDetailsPersonalDataManualBoxPoint>
      <OfferDetailsPersonalDataManualBoxPoint number={5}>
        Ciesz się wyjątkowymi prezentami
        <strong className="text-primary"> już od pierwszego dnia.</strong>
      </OfferDetailsPersonalDataManualBoxPoint>
      <OfferDetailsPersonalDataManualBoxPoint number={6}>
        <strong className="text-primary">Jak korzystać z ofert na preferencyjnych warunkach?</strong> Znajdując się na
        naszej stronie, bądź zawsze zalogowany do{' '}
        <a className="fw-bold text-decoration-none" href={CLIENT_APP_URLS.MAIN_PAGE} target="_blank">
          Konta Gościa.
        </a>
      </OfferDetailsPersonalDataManualBoxPoint>
    </div>
  </OfferDetailsRow>
)
